import Metrics from 'services/metrics';

export const EVENTS = {
  TV: 'TV',
  VOD: 'Reproductor',
  FIN_PLAYER: 'Fin Player',
};

export const CATEGORY = {
  TV_PLAYER: 'reproductor tv',
  PLAYER: 'reproductor',
  SCHEDULE: 'guia de programacion',
  FIN_PLAYER: 'fin player',
};

export const ACTIONS = {
  CLICK: 'click',
  CHANNEL_OPTIONS: 'opciones del programa',
  PIN: 'pin de seguridad',
  REMINDER: 'programar recordatorio',
  CONTROL_PLAYER: 'control player',
};

export const pushEvent = (event, category, action, label) => {
  Metrics.newEvent({
    event,
    gaCategory: category,
    gaAction: action,
    gaLabel: label,
  });
};

export const pushGTMEvent = options => {
  Metrics.newEvent({
    ...options,
  });
};

export const setEevntToAnalyticsG4 = (evento, data, pipIdioma, progress) => {
  let category = '';
  let availability = '';
  const addon = data?.group?.common?.extendedcommon?.media?.proveedor?.codigo;
  const genres = data?.group?.common?.extendedcommon?.genres?.genre;

  if (genres) {
    for (let i of genres) {
      category = category + i?.name + ' ';
    }
  } else {
    category = '';
  }

  switch (data?.group?.common?.extendedcommon?.format?.sell_type) {
    case 'susc':
      availability = 'por suscripcion';
      break;
    case 'free':
      availability = 'gratuito';
      break;
    case 'ppe':
      availability = 'alquiler';
      break;
    case 'est':
      availability = '';
      break;
    default:
      break;
  }

  const eventInfo = {
    event: evento,
    content_id: data?.group?.common?.id,
    content_name: data?.group?.common?.title,
    content_category: category,
    content_availability: `${availability} ${addon}`,
  };

  if (
    data?.group?.common?.extendedcommon?.media?.episode?.season &&
    data?.group?.common?.extendedcommon?.media?.episode?.number
  ) {
    if (evento && data && pipIdioma && !progress) {
      Metrics.newEvent({
        ...eventInfo,
        content_episode: `${data?.group?.common?.title} ${
          data?.group?.common?.extendedcommon?.media?.episode?.number
        }`,
        content_list: `${
          data?.group?.common?.extendedcommon?.media?.episode?.season
        }`,
        content_type: 'serie',
        interaction_type: pipIdioma,
      });
      return;
    }
    if (evento && data && pipIdioma && progress) {
      Metrics.newEvent({
        ...eventInfo,
        content_episode: `${data?.group?.common?.title} ${
          data?.group?.common?.extendedcommon?.media?.episode?.number
        }`,
        content_list: `${
          data?.group?.common?.extendedcommon?.media?.episode?.season
        }`,
        content_type: 'serie',
        progress_percentage: `${progress}%`,
      });
      return;
    }
    Metrics.newEvent({
      ...eventInfo,
      content_episode: `${data?.group?.common?.title} ${
        data?.group?.common?.extendedcommon?.media?.episode?.number
      }`,
      content_list: `${
        data?.group?.common?.extendedcommon?.media?.episode?.season
      }`,
      content_type: 'serie',
    });
    return;
  }
  const typeContent =
    data?.group?.common?.extendedcommon?.media?.islive === '0'
      ? 'pelicula'
      : 'canal tv';
  if (evento && data && pipIdioma && !progress) {
    Metrics.newEvent({
      ...eventInfo,
      content_episode: `no aplica`,
      content_list: `no aplica`,
      content_type: typeContent,
      interaction_type: pipIdioma,
    });
    return;
  }
  if (evento && data && pipIdioma && progress) {
    Metrics.newEvent({
      ...eventInfo,
      content_episode: `no aplica`,
      content_list: `no aplica`,
      content_type: typeContent,
      progress_percentage: `${progress}%`,
    });
    return;
  }
  Metrics.newEvent({
    ...eventInfo,
    content_episode: `no aplica`,
    content_list: `no aplica`,
    content_type: typeContent,
  });
};
